export const getSearchResult = (state) => state.search.posts;
